import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Add } from '@mui/icons-material';
import {
  getDadosUsuario,
  getClienteStatus,
  getClienteAtual,
  getReenviaDocumento
} from 'shared/services/User';
import NivelUsuarioEnum from 'shared/Enums/NivelUsuarioEnum';
import ButtonMain from '../../../shared/ButtonMain';
import ToggleButtonMain from '../../../shared/ToggleButtonMain';
import DocumentoUpload from '../../../shared/DocumentoUpload';
import LoaderMain from '../../../shared/LoaderMain';
import AlertErroMain from '../../../shared/AlertErroMain';
import {
  getListaTiposEmpresa,
  getDocumentosRequeridos,
  postConfirmarDocumentos,
  getListaTiposDocumentos,
  listarInfosEmpresa,
  listarEnderecoEmpresa
} from '../../../../../api/onboarding';

export default ({
  avancarEtapa,
  isPending,
  setPending,
  cnpjEmpresa,
  origemProposta = 'digital',
  codEntrada = null
}) => {
  const [listaTiposEmpresa, setListaTiposEmpresa] = useState([]);
  const [tipoEmpresa, setTipoEmpresa] = useState(0);
  const [erroTipoEmpresa, setErroTipoEmpresa] = useState('');
  const [documentosEmpresa, setDocumentosEmpresa] = useState([]);
  const [isPendingTipoEmpresas, setPendingTipoEmpresas] = useState(false);
  const [isPendingDocumento, setPendingDocumento] = useState(false);
  const [isPendingDocumentosEmpresa, setPendingDocumentosEmpresa] = useState(false);
  const [mostraErro, setMostraErro] = useState(false);
  const [tiposArquivosAceitos, setTiposArquivosAceitos] = useState(['pdf']);
  const [listaTiposDocumentos, setListaTiposDocumentos] = useState([]);
  const [listaTiposDocInseridos, setListaTiposDocInseridos] = useState([]);
  const [newDocOpen, setNewDocOpen] = useState(false);
  const [informacoesEmpresa, setInformacoesEmpresa] = useState({
    faturamento: 0,
    enderecoEmpresa: {}
  });
  const niveisPermitidos = [NivelUsuarioEnum.PROSPECT, NivelUsuarioEnum.CLIENTE];
  const clienteAtual = getClienteStatus();
  const reenviarDoc = getReenviaDocumento();

  // -----------------------------
  // TIPOS DE EMPRESA
  // -----------------------------
  useEffect(() => {
    setPendingTipoEmpresas(true);

    getListaTiposEmpresa()
      .then(retorno => {
        let dadosListaTemp = {};
        if (Object.keys(retorno.data).length > 0) {
          retorno.data.dados.map(dados => {
            return (dadosListaTemp[dados.SIGLA] = {
              valor: dados.SIGLA,
              label: dados.SIGLAJORNADA,
              xl: 2,
              lg: 2,
              md: 3,
              xs: 6
            });
          });
        }
        setListaTiposEmpresa(dadosListaTemp);
      })
      .finally(() => {
        setPendingTipoEmpresas(false);
      });

    let tiposArqAceitos = ['pdf'];
    if (
      origemProposta === 'connect' ||
      origemProposta === 'indicantes' ||
      origemProposta === 'interno'
    ) {
      tiposArqAceitos = ['pdf', 'imagens', 'word', 'powerPoint', 'excel'];
    } else if (origemProposta === 'one7_mais_credito') {
      tiposArqAceitos = ['pdf', 'png', 'jpg'];
    }
    setTiposArquivosAceitos(tiposArqAceitos);
  }, []);

  const alterarTipoEmpresa = novoTipo => {
    const userInfo = getDadosUsuario();
    setDocumentosEmpresa([]);
    setErroTipoEmpresa('');
    setPendingDocumentosEmpresa(true);
    setTipoEmpresa(novoTipo);

    getDocumentosRequeridos(novoTipo, origemProposta)
      .then(retorno => {
        if (retorno.status === 200 && Object.keys(retorno.data).length > 0) {
          let docs = retorno.data.documentos;

          const renomeacoes = {
            ENDIVIDAMENTO: 'ENDIVIDAMENTO BANCOS E FIDCS',
            'CURVA ABC DE CLIENTES': 'RELAÇÃO DE SACADOS OU CURVA ABC'
          };

          const docsTratados = [];

          docs.forEach(doc => {
            // se for documento especial e usuário não tem nível permitido, remove (não entra na lista)
            const docsEspeciais = [
              'RECUPERAÇÃO JUDICIAL',
              'RELAÇÃO DE FROTA',
              'BALANÇO/DRE',
              'ÚLTIMA ALTERAÇÃO CONTRATUAL'
            ];

            if (
              docsEspeciais.includes(doc.nome_doc) &&
              userInfo &&
              !niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta !== 'interno'
            ) {
              return; // pula este doc
            }

            // Caso especial: FATURAMENTO gera múltiplos docs
            if (
              doc.nome_doc === 'FATURAMENTO' &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              [12, 24, 36].forEach(meses => {
                docsTratados.push({
                  ...doc,
                  id: `${doc.id}-${meses}`,
                  id_original: doc.id,
                  obrigacao_doc: true,
                  explicacao_doc: `FATURAMENTO DOS ÚLTIMOS ${meses} MESES`,
                  observacao_padrao: `FATURAMENTO ${meses} MESES`,
                  observacao: `FATURAMENTO ${meses} MESES`
                });
              });
              return;
            }

            // Caso especial: BALANÇO/DRE gera 2 versões
            if (
              doc.nome_doc === 'BALANÇO/DRE' &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              // ano corrente
              docsTratados.push({
                ...doc,
                id: `${doc.id}-corrente`,
                id_original: doc.id,
                obrigacao_doc: true,
                explicacao_doc: 'Balancete/DRE do ano corrente',
                observacao_padrao: 'Balancete/DRE do ano corrente',
                observacao: 'Balancete/DRE do ano corrente'
              });

              // ano anterior
              docsTratados.push({
                ...doc,
                id: `${doc.id}-anterior`,
                id_original: doc.id,
                obrigacao_doc: true,
                explicacao_doc: 'Balancete/DRE do ano anterior',
                observacao_padrao: 'Balancete/DRE do ano anterior',
                observacao: 'Balancete/DRE do ano anterior'
              });

              return;
            }

            // cria cópia para aplicar regras normais
            let docTemp = { ...doc };

            // Regra 1 - Renomeações
            if (
              renomeacoes[docTemp.nome_doc] &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              docTemp.nome_doc = renomeacoes[docTemp.nome_doc];
            }

            // Regra 2 - Última Alteração Contratual obrigatória fora de SP
            if (
              docTemp.nome_doc === 'ÚLTIMA ALTERAÇÃO CONTRATUAL' &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              const isForaSP =
                informacoesEmpresa.enderecoEmpresa.UF && informacoesEmpresa.enderecoEmpresa.UF !== 'SP';

              docTemp.obrigacao_doc = isForaSP;
            }

            // Regra 3 - Recuperação Judicial
            if (
              docTemp.nome_doc === 'RECUPERAÇÃO JUDICIAL' &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              const isForaSP =
                informacoesEmpresa.enderecoEmpresa.UF && informacoesEmpresa.enderecoEmpresa.UF !== 'SP';

              docTemp = {
                ...docTemp,
                nome_doc: 'EMPRESAS EM RJ',
                obrigacao_doc: isForaSP ? false : docTemp.obrigacao_doc,
                explicacao_doc: 'Deve ser incluído se estiver em RJ'
              };
            }

            // Regra 4 - Relação de Frota
            if (
              docTemp.nome_doc === 'RELAÇÃO DE FROTA' &&
              userInfo &&
              niveisPermitidos.includes(userInfo.nivel) &&
              clienteAtual.ppc_status.tipo_origem_proposta === 'interno'
            ) {
              docTemp = {
                ...docTemp,
                nome_doc: 'RELAÇÃO DE FROTA',
                obrigacao_doc: false,
                explicacao_doc: 'Deve ser incluído se for do ramo de transporte.'
              };
            }

            // push final para docs que não foram tratados como especiais
            docsTratados.push(docTemp);
          });

          let docsFinal = [...docsTratados];

          if (reenviarDoc === 'S') {
            docsFinal = docsFinal.map(d => ({ ...d, obrigacao_doc: false }));
          }

          // ordena: true primeiro, false depois
          docsFinal.sort((a, b) => Number(b.obrigacao_doc === true) - Number(a.obrigacao_doc === true));

          setDocumentosEmpresa(docsFinal);
        } else {
          setDocumentosEmpresa([]);
        }
      })
      .finally(() => {
        setPendingDocumentosEmpresa(false);
      });
  };

  // -----------------------------
  // CONFIRMAR DOCUMENTOS
  // -----------------------------
  const confirmarDocumentosEmpresa = () => {
    let bloquearSubmit = false;
    let precisaTipoNovoDoc = false;

    const documentosEmpresaTemp = documentosEmpresa.map(doc => {
      // valida se new_doc ainda está sem tipo/arquivo
      if (doc.id === 'new_doc' && (!doc.id_original || !doc.link_arquivo)) {
        precisaTipoNovoDoc = true;
      }

      if ((!doc.link_arquivo || doc.link_arquivo === '') && doc.obrigacao_doc) {
        bloquearSubmit = true;
        doc.status = 'reprovado';
        doc.titulo_status = 'Pendente';
        doc.subtitulo_status = 'Favor importar um arquivo para este documento';
      }

      return doc;
    });

    if (precisaTipoNovoDoc) {
      setMostraErro({
        data: {
          mensagem: 'Por favor, selecione o tipo e adicione um arquivo para o novo documento.'
        }
      });
      return false;
    }

    if (bloquearSubmit) {
      setDocumentosEmpresa([...documentosEmpresaTemp]);
      return false;
    }

    const docsValidos = documentosEmpresaTemp.filter(d => d.link_arquivo || d.nome_arquivo);

    if (reenviarDoc === 'S' && docsValidos.length === 0) {
      avancarEtapa('DCS');
      return;
    }

    const params = formatarPayload(docsValidos);

    if (origemProposta === 'one7_mais_credito') {
      setPendingDocumentosEmpresa(true);
    } else {
      setPending(true);
    }

    postConfirmarDocumentos(params)
      .then(response => {
        if (response.data && response.data.dados.processado === false) {
          setMostraErro(response.data.mensagem);
          return;
        } else {
          avancarEtapa('DCS');
        }
      })
      .catch(err => {
        setMostraErro(err.response);
      })
      .finally(() => {
        setPending(false);
        setPendingDocumentosEmpresa(false);
      });
  };

  const formatarPayload = dadosDocumentos => {
    const infoUser = getDadosUsuario();

    const tempDocs = dadosDocumentos
      .filter(doc => doc.link_arquivo || doc.nome_arquivo)
      .map(doc => ({
        cpf_socio: null,
        cpf_conjugue: null,
        hash: doc.nome_arquivo,
        cod_documento: doc.id_original ? doc.id_original : doc.id,
        observacao: doc.observacao ? doc.observacao : null,
        tipo: null
      }));

    return {
      cnpj: cnpjEmpresa,
      reenviar_doc: reenviarDoc === 'S' ? 'S' : 'N',
      nivel_usuario: infoUser && infoUser.nivel ? infoUser.nivel : null,
      cod_entrada: codEntrada,
      origem_proposta: origemProposta,
      tipo_empresa: tipoEmpresa,
      valida_documento: true,
      envia_email: false,
      documentos: tempDocs
    };
  };

  // -----------------------------
  // BUSCAR TIPOS DE DOCUMENTOS (regras faturamento e UF)
  // -----------------------------
  const buscaTiposDocumentos = () => {
    const infoUsuario = getDadosUsuario();

    getListaTiposDocumentos()
      .then(retornoTipos => {
        let ret = retornoTipos.data;
        if (ret.dados && ret.dados.length > 0) {
          if (infoUsuario && niveisPermitidos.includes(infoUsuario.nivel)) {
            if (
              Number(informacoesEmpresa.faturamento) >= 24000000 &&
              Number(informacoesEmpresa.faturamento) <= 60000000 &&
              reenviarDoc &&
              reenviarDoc !== 'S'
            ) {
              const extras = ret.dados
                .filter(doc => ['IMPOSTO DE RENDA', 'BACEN', 'BALANÇO PATRIMONIAL'].includes(doc.NOME))
                .map(doc => ({
                  id: doc.CODPPCDOCUMENTO,
                  nome_doc: doc.NOME,
                  explicacao_doc: doc.DESCRICAO,
                  obrigacao_doc: true
                }));

              const idsAtuais = new Set(documentosEmpresa.map(d => d.id));
              const novos = extras.filter(doc => !idsAtuais.has(doc.id));

              setDocumentosEmpresa(prev => {
                const merged = [...prev, ...novos];
                return merged.sort(
                  (a, b) =>
                    Number(b.obrigacao_doc) - Number(a.obrigacao_doc) ||
                    a.nome_doc.localeCompare(b.nome_doc)
                );
              });
            }

            if (
              informacoesEmpresa.enderecoEmpresa.UF &&
              informacoesEmpresa.enderecoEmpresa.UF !== 'SP' &&
              reenviarDoc &&
              reenviarDoc !== 'S'
            ) {
              const contratoSocial = ret.dados.find(doc => doc.CODPPCDOCUMENTO === 5);
              if (contratoSocial) {
                const jaExiste = documentosEmpresa.some(d => d.id === contratoSocial.CODPPCDOCUMENTO);
                if (!jaExiste) {
                  setDocumentosEmpresa(prev => {
                    const merged = [
                      ...prev,
                      {
                        id: contratoSocial.CODPPCDOCUMENTO,
                        nome_doc: contratoSocial.NOME,
                        explicacao_doc: contratoSocial.DESCRICAO,
                        obrigacao_doc: true
                      }
                    ];
                    return merged.sort(
                      (a, b) =>
                        Number(b.obrigacao_doc) - Number(a.obrigacao_doc) ||
                        a.nome_doc.localeCompare(b.nome_doc)
                    );
                  });
                }
              }
            }

            setListaTiposDocumentos(ret.dados);
          } else {
            setListaTiposDocumentos(ret.dados);
          }
        }
      })
      .catch(err => {
        setMostraErro(err.response);
      });
  };

  useEffect(() => {
    if (
      origemProposta === 'connect' ||
      origemProposta === 'indicantes' ||
      origemProposta === 'interno'
    ) {
      if (documentosEmpresa.length > 0 && listaTiposDocumentos.length === 0) {
        buscaTiposDocumentos();
      }

      let newDoc = false;
      let lstTiposDocInsTemp = [...listaTiposDocInseridos];
      documentosEmpresa.map(doc => {
        if (doc.id === 'new_doc') newDoc = true;
        if (doc.status !== 'reprovado' && doc.id !== 'new_doc')
          lstTiposDocInsTemp.push(doc.cod_documento);
        return doc;
      });
      setNewDocOpen(newDoc);
      setListaTiposDocInseridos(lstTiposDocInsTemp);
    }
  }, [documentosEmpresa]);

  // -----------------------------
  // SALVAR NOVO DOCUMENTO
  // -----------------------------
  const salvarNovoDocumento = (indexArquivo, tipoNovoDoc) => {
    if (
      origemProposta === 'connect' ||
      origemProposta === 'indicantes' ||
      origemProposta === 'interno'
    ) {
      if (
        tipoNovoDoc &&
        tipoNovoDoc.CODPPCDOCUMENTO &&
        (documentosEmpresa[indexArquivo].link_arquivo || documentosEmpresa[indexArquivo].nome_arquivo)
      ) {
        let newListaDocs = documentosEmpresa.map(doc => {
          if (doc.id === 'new_doc') {
            doc.descricao = tipoNovoDoc.DESCRICAO;
            doc.explicacao_doc = tipoNovoDoc.DESCRICAO;
            doc.nome = tipoNovoDoc.NOME;
            doc.nome_doc = tipoNovoDoc.NOME;
            doc.obrigacao_doc = false;
            doc.requerido = false;
            doc.id = tipoNovoDoc.CODPPCDOCUMENTO + `_${documentosEmpresa.length}`;
            doc.id_original = tipoNovoDoc.CODPPCDOCUMENTO;
            delete doc['novo_doc_lista'];
          }
          return doc;
        });

        setDocumentosEmpresa(newListaDocs);
      }
    }
  };

  const novoDocumento = () => {
    if (newDocOpen || documentosEmpresa === undefined) return false;
    let listaDocsTemp = [...documentosEmpresa];
    let lstTiposDoc = listaTiposDocumentos.filter(
      tipoDoc => listaTiposDocInseridos.includes(tipoDoc.CODPPCDOCUMENTO) === false
    );
    listaDocsTemp.unshift({ id: 'new_doc', novo_doc_lista: lstTiposDoc });
    setDocumentosEmpresa(listaDocsTemp);
  };

  // -----------------------------
  // INFOS EMPRESA
  // -----------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const clienteAtual = getClienteAtual();
        const infosStatus = getClienteStatus();
        const codppc = infosStatus ? infosStatus.ppc_status.codppc : 0;
        const response = await listarInfosEmpresa(codppc);

        const res = await listarEnderecoEmpresa({ cnpj: clienteAtual.cnpj });
        const enderecoEmpresa = res.data;
        if (codppc) {
          const fatAnulEmpresa = Number(response.data);
          setInformacoesEmpresa({
            faturamento: fatAnulEmpresa,
            enderecoEmpresa
          });
        }
      } catch (err) {
        setMostraErro(err.response);
      }
    };

    fetchData();
  }, []);

  // -----------------------------
  // RENDER
  // -----------------------------
  return (
    <Grid container>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <Box
          className="mt-2"
          sx={
            isPendingTipoEmpresas
              ? { position: 'relative', p: '15px 0 0 0', minHeight: '150px' }
              : { p: '15px 0 0 0' }
          }
        >
          {isPendingTipoEmpresas && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
          <ToggleButtonMain
            titulo="Tipo de empresa"
            tipo="input"
            nomeInput="tipo_empresa"
            funcaoHandleChange={alterarTipoEmpresa}
            erro={erroTipoEmpresa}
            atributoHandle={tipoEmpresa}
            atributosBotao={{ disabled: isPending || isPendingDocumento || isPendingDocumentosEmpresa }}
            botoes={Object.values(listaTiposEmpresa)}
          />
        </Box>

        <Box
          sx={
            isPendingDocumentosEmpresa
              ? { position: 'relative', p: '15px 0 0 0', minHeight: '150px' }
              : { p: '15px 0 0 0' }
          }
        >
          {isPendingDocumentosEmpresa && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
          {documentosEmpresa.length !== 0 && (
            <Box className="borda-1 borda-cor-suporte pad-15 border-radius-8 margin-bottom-35">
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro pad-5 texto-negrito">
                Para enviar os arquivos corretamente siga as instruções:
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro pad-5">
                <WbSunnyOutlinedIcon className="font-size-1-rem" />
                <span className="pad-5">Escolha um ambiente com boa iluminação e sem sombras</span>
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro pad-5">
                <InfoOutlinedIcon className="font-size-1-rem" />
                <span className="pad-5">
                  Retire a proteção plástica do documento para evitar reflexos
                </span>
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro pad-5">
                <LockOutlinedIcon className="font-size-1-rem" />
                <span className="pad-5">
                  Não se preocupe! Coletamos e tratamos seus dados para fins de identificação,
                  autenticação e prevenção de fraudes. Esse processo é 100% confidencial
                </span>
              </Typography>
            </Box>
          )}

          {documentosEmpresa.length !== 0 &&
            (origemProposta === 'connect' ||
              origemProposta === 'indicantes' ||
              origemProposta === 'interno') && (
              <ButtonMain
                tipoBotao="principal-texto-branco"
                disabled={newDocOpen || isPendingDocumento || listaTiposDocumentos.length === 0}
                onClick={novoDocumento}
              >
                <Add />
                Novo Documento
              </ButtonMain>
            )}

          {documentosEmpresa.map((doc, index) => {
            var bordaBottom =
              index + 1 === documentosEmpresa.length ? 'borda-transparente' : 'borda-cor-cinza-claro';

            return (
              <DocumentoUpload
                key={doc.id}
                id={doc.id}
                boxClassesAdicionais={bordaBottom}
                isPending={isPendingDocumento}
                setPending={setPendingDocumento}
                listaDocs={documentosEmpresa}
                setListaDocs={setDocumentosEmpresa}
                arquivosAceitos={tiposArquivosAceitos}
                tamanhoMaximoMegaAceito={30}
                cnpjEmpresa={cnpjEmpresa}
                btnEnviarDocumento={false}
                funcaoSalvarNovoDocumento={salvarNovoDocumento}
                renomearArquivoPorTipoDocumento={true}
                inputObservacao={
                  origemProposta === 'connect' ||
                  origemProposta === 'indicantes' ||
                  origemProposta === 'interno'
                }
              />
            );
          })}

          {documentosEmpresa.length === 0 && tipoEmpresa !== 0 && !isPendingDocumentosEmpresa && (
            <Typography variant="h6" className="mt-3 texto-negrito texto-centro">
              Não foram encontrados documentos para este tipo de empresa
            </Typography>
          )}
        </Box>

        <AlertErroMain exibeErro={mostraErro} escondeErro={setMostraErro} />

        <Grid container className="mt-3" spacing={3}>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12} />
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
            <center>
              <ButtonMain
                tipoBotao="principal"
                disabled={
                  isPending || isPendingDocumento || isPendingDocumentosEmpresa || tipoEmpresa === 0
                }
                onClick={confirmarDocumentosEmpresa}
              >
                Continuar
              </ButtonMain>
            </center>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
